import { RegistryItemFragment } from '@graphql/generated';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useDisclosure } from '@withjoy/joykit';
import { useEffect, useState } from 'react';
import { createRegistryItemSubject } from '../..';

let globalOpenDrawerImmediately: (() => void) | null = null;

export const useDrawerVisibilty = () => {
  const [currentItem, setCurrentItem] = useState<RegistryItemFragment | null>(null);
  const [isAddingItem, setIsAddingItem] = useState(false);
  const { isOpen, onClose, onOpen } = useDisclosure();

  const openDrawerImmediately = useEventCallback(() => {
    setIsAddingItem(true);
    onOpen();
  });

  const closeDrawer = useEventCallback(() => {
    setIsAddingItem(false);
    setCurrentItem(null);
    onClose();
  });

  useEffect(() => {
    const sub = createRegistryItemSubject.subscribe(data => {
      if (!data.purchaseMethod) {
        setCurrentItem(data.item);
        setIsAddingItem(false);
      }
    });

    return () => {
      sub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    globalOpenDrawerImmediately = openDrawerImmediately;
    return () => {
      globalOpenDrawerImmediately = null;
    };
  }, [openDrawerImmediately]);

  return {
    currentItem,
    isOpen,
    isAddingItem,
    onClose: closeDrawer,
    openDrawerImmediately,
  };
};

export const triggerDrawerOpen = () => {
  if (globalOpenDrawerImmediately) {
    globalOpenDrawerImmediately();
  }
};
